/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Why_BodyInputs */

const en_us2_profile_why_body = /** @type {(inputs: Profile_Why_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your weight tracks your progress and feeds the bodyweight exercises.`)
};

const pt_br2_profile_why_body = /** @type {(inputs: Profile_Why_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O peso acompanha sua evolução e entra nos exercícios com peso do corpo.`)
};

const es_419_profile_why_body = /** @type {(inputs: Profile_Why_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu peso sigue tu progreso y se usa en los ejercicios con peso corporal.`)
};

const pt_pt2_profile_why_body = /** @type {(inputs: Profile_Why_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O peso acompanha a tua evolução e entra nos exercícios com o peso do corpo.`)
};

const fr_fr2_profile_why_body = /** @type {(inputs: Profile_Why_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton poids suit ta progression et sert pour les exercices au poids de corps.`)
};

const de_de2_profile_why_body = /** @type {(inputs: Profile_Why_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Gewicht zeigt deinen Fortschritt und fließt in die Übungen mit Körpergewicht ein.`)
};

const it_it2_profile_why_body = /** @type {(inputs: Profile_Why_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il peso segue i tuoi progressi e conta negli esercizi a corpo libero.`)
};

/**
* | output |
* | --- |
* | "Your weight tracks your progress and feeds the bodyweight exercises." |
*
* @param {Profile_Why_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_why_body = /** @type {((inputs?: Profile_Why_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Why_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_why_body(inputs)
	if (locale === "es-419") return es_419_profile_why_body(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_why_body(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_why_body(inputs)
	if (locale === "de-DE") return de_de2_profile_why_body(inputs)
	if (locale === "it-IT") return it_it2_profile_why_body(inputs)
	return en_us2_profile_why_body(inputs)
});
export { profile_why_body as "profile.why_body" }